// ============================================================================
// Change project on an invoice line — the client-side rules. Item #542 part 2,
// TCSD-0490; Ben's picks on the demo page, 2026-10-19.
//
// change_invoice_line_project enforces every one of these again in the
// database. These only decide what the screen offers.
// ============================================================================

import { DRAFT_STATUSES } from './hooks/use-invoicing-data';

/** Decision 1: only before the bill goes to the client. */
export function canChangeProjectOn(status: string, financeCapable: boolean): boolean {
  return financeCapable && DRAFT_STATUSES.includes(status);
}

/**
 * Decision 2: the same test drafting uses — this building, Ready to Invoice,
 * on no invoice — and not the project the line already bills.
 */
export function isRepointTarget(
  row: { id: string; raw: Record<string, unknown> },
  facilityId: string | null,
  currentProjectId: string | null,
): boolean {
  return (
    row.id !== currentProjectId &&
    facilityId != null &&
    row.raw.facility_id === facilityId &&
    row.raw.stage === 'Ready_to_Invoice' &&
    !row.raw.invoice_id
  );
}
